export default __webpack_public_path__ + "static/tintri-74c2134455357ff4c213dbcb9445fb6e.jpg";